<template lang="pug">
.sharepoint-modal
  b-modal(id="projectmodal", :title="title", size="lg", ok-variant="primary", ref="projectmodal", ok-title="Speichern", cancel-title="Abbrechen", @ok="save").modal-fullscreen2
    div.form-group
      label(for="projectName").small Projektname
      input.form-control(type="text", v-model="projectName" required)

      .mt-3
        label(for="projectName", size="small").small Eigenes Anlagenkennzeichnungssystem
        input.form-control(type="text", v-model="identificationSystem", placeholder="Regex z.B. \"(\\d|[A-Z])(\\d{0,2})[A-Z]{1,3}\\d{1,2}\", leer lassen für KKS", required)
      
      .mt-3
     
        b-check(type="text", v-model="identification_system_ri_active").small Zweizeilige KKS parsen und zusammenführen (R&amp;I KKS)
        input.form-control(type="text", v-model="identification_system_ri_first", placeholder="Regex erste Zeile", :disabled="!identification_system_ri_active")
        input.form-control(type="text", v-model="identification_system_ri_second", placeholder="Regex zweite Zeile", :disabled="!identification_system_ri_active")
      
      .mt-3
        b-check(type="text", v-model="normalize_kks") KKS normalisieren (Leerzeichen entfernen)

      .mt-3
        label(for="coverpage").small Deckblatt-Vorlage
        select.form-control(v-model="selectedCoverpage")
          option(value="") Kein Deckblatt
          option(v-for="coverpage in coverpages" :key="coverpage.name" :value="coverpage.name") {{ coverpage.name }}

      .mt-3
        label(for="compressionStrategy").small PDF-Komprimierung beim Import
        select.form-control(v-model="compressionStrategy")
          option(value="none") Keine Komprimierung
          option(value="normal") Normal komprimieren
          option(value="strong") Stark komprimieren
        .mt-2(v-if="compressionStrategy !== 'none'")
          b-form-checkbox(v-model="compressionOnlyLargeFiles") Nur Dateien &gt; 10 MB komprimieren

      .mt-3
        b-button(variant="link" @click.prevent="showRegexTips = !showRegexTips" href="#", size="sm").p-0.small 
          span(v-if="showRegexTips") Regex Hilfe verbergen
          span(v-else) Regex Hilfe anzeigen

        div(v-if="showRegexTips").p-3.bg-light.border.rounded

          .d-flex.justify-content-between
            
              ul.list.small.px-3
                li \d = Ziffer
                li \d{0,2} = 0-2 Ziffern
                li [A-Z] = Großbuchstabe
                li [A-Z]{1,3} = 1-3 Großbuchstaben
                li \d|[A-Z] = Ziffer oder Großbuchstabe

              div
                b-button(:href="'https://regex101.com?regex=' + (identificationSystem ? identificationSystem : '')" target="_blank", size="sm").small Regex testen
          .mt-3
            a(href="#" @click.prevent="identificationSystem = `(\\\\d|[A-Z])\\\\d{0,2}[A-Z]{1,3}\\\\d{1,2}( |-|  )?[A-Z]{1,2}\\\\d{1,3}[A-Z]?(-)?(([A-Z]{1,2}\\\\d{1,2})|(\\\\d{1,3}))?`").small Standard-KKS
          //.mt-1 
            //a(href="#" @click.prevent="identificationSystem = `(\\\\d|[A-Z])\\\\d{0,2}[A-Z]{1,3}\\\\d{1,2}( |-|  |\\\\n)?[A-Z]{1,2}\\\\d{1,3}[A-Z]?(-)?(([A-Z]{1,2}\\\\d{1,2})|(\\\\d{1,3}))?|([A-Z]{1,2}\\\\d{1,3}[A-Z]?(-)?(([A-Z]{1,2}\\\\d{1,2})|(\\\\d{1,3}))?(\\\\n)(\\\\d|[A-Z])\\\\d{0,2}[A-Z]{1,3}\\\\d{1,2})`").small R&amp;I KKS
         
      .mt-3
        div(v-if="internal_class_config")
          table.table.table-sm.table-striped
            tr
              th Klasse
              th(v-if="project && !project._id") Als Standardliste initialisieren
              th Als gesamtes Dokument erhalten
              th Splits auf Export setzen
            tr(v-for="(it, key, index) in internal_class_config")
              td {{ key }}
              td(v-if="project && !project._id")
                b-form-checkbox(v-model="it.init_detail_list", :value="true", :unchecked-value="false") 
              td
                b-form-checkbox(v-model="it.keep_whole_document", :value="true", :unchecked-value="false") 
              td
                b-form-checkbox(v-model="it.always_export_split", :value="true", :unchecked-value="false")
      
      .mt-3.border-top.pt-3
        b-form-checkbox(v-model="keyword_check", :value="true", :unchecked-value="false") Projekt in Keyword-Auswertung mit einbeziehen

      .mt-3.border-top.pt-3
        b-form-checkbox(v-model="archived", :value="true", :unchecked-value="false") Projekt archivieren
        
              
</template>

<script>
// @ is an alias to /src


import Vue from 'vue'

export default {

  name: 'projectmodal',
  props: [],

  data() {
    return {
      showRegexTips: false,
      selectedResult: 0,
      project: null,
      projectName: "",
      fileConfig: "{kks}_{class_name}_{dcc}",
      loading: true,
      document: null,
      page_p: 1,
      title: "Projekt",
      identificationSystem: null,
      normalize_kks: false,
      identification_system_ri_active: false,
      identification_system_ri_first: "^(\\d|[A-Z])( )?\\d{0,2}[A-Z]{1,3}\\d{1,2}$",
      identification_system_ri_second: "^[A-Z]{1,2}\\d{1,3}[A-Z]?(-)?(([A-Z]{1,2}\\d{1,2})|(\\d{1,3}))?$",
      keyword_check: false,
      archived: false,
      options: { 'withCredentials': true },
      pageCount: 0,
      dicectories: [],
      config: null,
      internal_class_config: {},
      coverpages: [],
      selectedCoverpage: "",
      compressionStrategy: "none",
      compressionOnlyLargeFiles: false

    }
  },

  watch: {
    identification_system_ri_active: function (val) {
      if (val) {
        if(!this.identification_system_ri_first) this.identification_system_ri_first = "^(\\d|[A-Z])( )?\\d{0,2}[A-Z]{1,3}\\d{1,2}$";
        if(!this.identification_system_ri_second) this.identification_system_ri_second = "^[A-Z]{1,2}\\d{1,3}[A-Z]?(-)?(([A-Z]{1,2}\\d{1,2})|(\\d{1,3}))?$";
      }
    }
  },

  mounted: function () {
    this.fetchCoverpages();
  },



  methods: {
    fetchCoverpages() {
      this.axios
        .get(this.base_url + "/import/sharepoint/coverpages")
        .then((response) => {
          this.coverpages = response.data;
        })
        .catch((error) => {
          console.error("Error fetching coverpages:", error);
        });
    },

    save(ev) {
      if (this.projectName.trim() == "" || this.projectName.length < 3) {
        alert("Bitte geben Sie einen Projektnamen mit mind. 3 Zeichen ein.");
        ev.preventDefault();
        return;
      }
      if (!this.project._id) {

        this.$emit('save', { 
          "name": this.projectName, 
          "class_config": this.internal_class_config, 
          "identification_system": this.identificationSystem , 
          "normalize_kks": this.normalize_kks, 
          "identification_system_ri_active": this.identification_system_ri_active, 
          "identification_system_ri_first": this.identification_system_ri_first, 
          "identification_system_ri_second": this.identification_system_ri_second,
          "keyword_check": this.keyword_check,
          "archived": this.archived,
          "coverpage_template_file": this.selectedCoverpage,
          "compression_strategy": this.compressionStrategy,
          "compression_min_filesize_mb": this.compressionOnlyLargeFiles ? 10 : 0
        });
      } else {
        this.project.name = this.projectName;
        this.project.class_config = this.internal_class_config;
        this.project.normalize_kks = this.normalize_kks;
        this.project.identification_system_ri_active = this.identification_system_ri_active;
        this.project.identification_system_ri_first = this.identification_system_ri_first;
        this.project.identification_system_ri_second = this.identification_system_ri_second;
        this.project.identification_system = this.identificationSystem;
        this.project.keyword_check = this.keyword_check;
        this.project.archived = this.archived;
        this.project.coverpage_template_file = this.selectedCoverpage;
        this.project.compression_strategy = this.compressionStrategy;
        this.project.compression_min_filesize_mb = this.compressionOnlyLargeFiles ? 10 : 0;
        this.$emit('save', this.project);
      }

    },

    open(project) {

      if (project) {
        this.project = project;
        this.projectName = project.name;
        this.identificationSystem = project.identification_system;
        this.normalize_kks = project.normalize_kks;
        this.identification_system_ri_active = project.identification_system_ri_active;
        this.identification_system_ri_first = project.identification_system_ri_first;
        this.identification_system_ri_second = project.identification_system_ri_second;
        this.keyword_check = project.keyword_check;
        this.archived = project.archived_at ? true : false;
        this.selectedCoverpage = project.coverpage_template_file || "";
        this.compressionStrategy = project.compression_strategy || "none";
        this.compressionOnlyLargeFiles = project.compression_min_filesize_mb > 0;
      } else {
        this.projectName = "";
        this.project = { name: "", class_config: {} };
        this.identificationSystem = "";
        this.normalize_kks =  false;
        this.identification_system_ri_active = false;
        this.identification_system_ri_first = "^(\\d|[A-Z])( )?\\d{0,2}[A-Z]{1,3}\\d{1,2}$";
        this.identification_system_ri_second = "^[A-Z]{1,2}\\d{1,3}[A-Z]?(-)?(([A-Z]{1,2}\\d{1,2})|(\\d{1,3}))?$";
        this.keyword_check = true;
        this.archived = false;
        this.selectedCoverpage = "";
        this.compressionStrategy = "none";
        this.compressionOnlyLargeFiles = false;
      }

      // load dcc list
      this.axios
        .get(this.base_url + "/configuration/keywords")
        .then((response) => {
          let new_config = {};
          this.config = response.data;
          this.config.configurations.forEach((it) => {
            console.log(it);
            if (it.is_document_class) {

              if (project && project.class_config && project.class_config.hasOwnProperty(it.dcc_class)) {

                new_config[it.dcc_class] = this.project.class_config[it.dcc_class];
              } else {

                new_config[it.dcc_class] = {
                  "init_detail_list": true,
                  "keep_whole_document": it.keep_whole_document,
                  "always_export_split": it.always_export_split
                };
              }

            }

          });
          console.log(new_config);
          // sort by key

          new_config = Object.keys(new_config).sort().reduce(
            (obj, key) => {
              obj[key] = new_config[key];
              return obj;
            },
            {}
          );

          this.internal_class_config = new_config;

          this.$forceUpdate();

        });
      this.$refs.projectmodal.show();

    }


  },

  components: {

  }
}

</script>

<style lang="scss" scoped>
::v-deep #onboardmodal>.modal-dialog {
  max-width: 100%;
  width: 100%;
  height: 100%;
}
</style>

